define([
    'text!product-detail/ymb/ymb-legs.html',
    'product-detail/ymb/ymb-leg-slick',
    'product-detail/mixin/product',

    'css!product-detail/ymb/ymb-legs.css'
], function(
    tpl,
    YmbLegSlick,
    ProductMixin
){
    return {
        template: tpl,
        mixins: [ProductMixin],
        components: {
            YmbLegSlick: YmbLegSlick
        },
        computed: {
            mainImage: function(){
                return this.selectedSkuExtra.mainImage || '';
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/ymb/ymb-legs.js
// module id = 293
// module chunks = 0